import type { Plugin } from 'vue'
import Loading from './loading'

const plugin: Plugin = {
  install(app) {
    app.directive(Loading.name, Loading)
  },
}

export default plugin
